import styled from "styled-components";

export const VideoSlideGameTitleLayoutBox = styled.div`
    text-overflow: ellipsis;
    width: 90%;
    font-size: 1.6rem;
    color: ${({theme}) => theme.colors.textLight.toString()};
    line-height: 1.1;
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    @media ${({theme}) => theme.mediaQuery.xlAndAbove } {
        font-size: 1.3rem;
    }
`;
